var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "socialMediaContainer" }, [
    _c("div", { staticClass: "socialMediaItem" }, [
      _c(
        "a",
        {
          attrs: { href: "https://www.instagram.com/ehrengardeneuwied/?hl=de" },
        },
        [
          _c("font-awesome-icon", {
            staticClass: "icon alt",
            attrs: { icon: ["fab", "instagram"] },
          }),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "socialMediaItem" }, [
      _c(
        "a",
        { attrs: { href: "https://de-de.facebook.com/Ehrengarde.Neuwied/" } },
        [
          _c("font-awesome-icon", {
            staticClass: "icon alt}",
            attrs: { icon: ["fab", "facebook"] },
          }),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "socialMediaItem" }, [
      _c(
        "a",
        { attrs: { href: "https://twitter.com/ehrengarde_nwd?lang=de" } },
        [
          _c("font-awesome-icon", {
            staticClass: "icon alt",
            attrs: { icon: ["fab", "twitter"] },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }